import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box, IconButton, Menu, MenuItem } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { getEditNewsRoute } from "../../../../../constants/routes"
import { MerchantNewsArticle } from "../merchantNewsItemType"

type CardDropdownMenuProps = Readonly<{
    article: MerchantNewsArticle
    setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
}>

export const CardDropdownMenu = ({ article, setShowDeleteModal }: CardDropdownMenuProps) => {
    const navigate = useNavigate()
    const [dropDownAnchorEl, setdropDownAnchorEl] = useState<null | HTMLElement>(null)

    const handledropDownClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setdropDownAnchorEl(event.currentTarget)
    }

    const handleDropDownClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setdropDownAnchorEl(null)
    }

    return (
        <Box sx={{ paddingLeft: "1rem" }}>
            <IconButton
                aria-label="more"
                aria-controls={`more-action-${article.id}`}
                aria-haspopup="true"
                onClick={handledropDownClick}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </IconButton>

            {dropDownAnchorEl && (
                <Menu
                    id={`more-action-${article.id}`}
                    anchorEl={dropDownAnchorEl}
                    open={Boolean(dropDownAnchorEl)}
                    onClose={handleDropDownClose}
                >
                    <LocalizedStrict id="news-edit">
                        <MenuItem
                            onClick={(e) => {
                                handleDropDownClose(e)
                                navigate(getEditNewsRoute(article.id))
                            }}
                        >
                            Edit
                        </MenuItem>
                    </LocalizedStrict>

                    <LocalizedStrict id="news-delete">
                        <MenuItem
                            onClick={(e) => {
                                handleDropDownClose(e)
                                setShowDeleteModal(true)
                            }}
                        >
                            Delete
                        </MenuItem>
                    </LocalizedStrict>
                </Menu>
            )}
        </Box>
    )
}
